<script setup lang="ts">
type WishListProps = {
  label?: string
  iconSource?: string
  iconSourceFilled?: string
  gaOptions?: Omit<DataLayerObject, 'event'>
  role?: string
  class?: string
  testId?: string
}

const props = defineProps<WishListProps>()
const userStore = useUserStore()

const { wishlist: wishlistUrl } = useSiteUrl()
const computedWishlistUrl = computed(() => (userStore.isLoggedIn ? wishlistUrl.authenticated : wishlistUrl.guest))
const wishlistStore = useWishlistStore()

const computedGaOptions = computed(() => ({
  ...props.gaOptions,
  label: 'Wishlist',
  category: 'main navigation',
  type: 'Wishlist',
  group: 'actions menu',
}))
</script>

<template>
  <client-only>
    <Anchor
      :url="computedWishlistUrl"
      :class="['wishlist', props.class]"
      :ga-options="computedGaOptions"
      :log-click="true"
      aria-label="Wishlist"
      :data-testid="testId"
    >
      <svg-icon name="mhj:heart-solid" v-if="wishlistStore.count > 0" data-testid="wishlist-icon-filled" />
      <svg-icon name="mhj:heart-border" v-else data-testid="wishlist-icon-empty" />
      <template v-if="label">{{ label }}</template>
    </Anchor>
    <template #fallback>
      <svg-icon :class="['wishlist', props.class]" name="mhj:heart-border" />
    </template>
  </client-only>
</template>

<style lang="postcss">
.wishlist {
  display: flex;
  text-decoration: none;
}
</style>
